import { render, staticRenderFns } from "./MyPriceChecker.vue?vue&type=template&id=5af84c72&"
import script from "./MyPriceChecker.vue?vue&type=script&lang=js&"
export * from "./MyPriceChecker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports